export const MAIN = '/'
